import { useTranslation } from 'react-i18next'
import type { QuebonReviewListItem } from '@/api/quebonReviews'
import basicProfile from '@/assets/reviews/basic-profile-new.svg'
import arrowIcon from '@/assets/reviews/icon-arrow-right-blue.svg'

interface Props {
  items: QuebonReviewListItem[]
  page: number
  totalPages: number
  loading: boolean
  onLoadMore: () => void
  onSelect: (id: number) => void
}

export default function ReviewList({
  items,
  page,
  totalPages,
  loading,
  onLoadMore,
  onSelect,
}: Props) {
  const { t } = useTranslation('common')
  const hasMore = page < totalPages

  return (
    <section id="review-list" data-marketing-section="" className="relative bg-[#4599ff]">
      <div
        aria-hidden
        className="absolute top-0 left-0 w-full h-[168px] md:h-[68px] bg-white"
      />
      <div className="max-w-[1180px] mx-auto relative px-6 pb-[124px]">
        <ul className="flex flex-col gap-4">
          {items.map((item) => (
            <li
              key={item.storyId}
              onClick={() => onSelect(item.storyId)}
              className="
                relative rounded-[24px] bg-white p-6 cursor-pointer
                shadow-[0_8px_16px_0_rgba(0,0,0,0.2)]
              "
            >
              <strong className="block text-[20px] font-bold text-[#131313] truncate">
                {item.title}
              </strong>
              <p
                className="mt-4 mb-4 text-[16px] text-[#505050]"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
                dangerouslySetInnerHTML={{ __html: item.preview }}
              />
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full overflow-hidden">
                    <img
                      src={basicProfile}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-[#aaa]">
                    {item.writer?.name ?? ''}
                    {t('reviews.list.writerSuffix')}
                  </span>
                </div>
                <span className="flex items-center gap-2 text-[#4599ff] font-medium">
                  {t('reviews.list.detail')}
                  <img src={arrowIcon} alt="" className="w-4 h-4" />
                </span>
              </div>
              {item.confirm === false && (
                <span
                  className="absolute top-0 right-0 px-1 py-0.5 text-white text-xs"
                  style={{ background: '#ff5a5a' }}
                >
                  미승인 후기
                </span>
              )}
            </li>
          ))}
        </ul>

        {hasMore && (
          <div className="flex justify-center mt-10">
            <button
              type="button"
              onClick={onLoadMore}
              disabled={loading}
              className="
                w-32 h-12 md:w-40 md:h-14 rounded-full
                bg-white/30 text-white text-[16px] md:text-[20px] font-medium
                flex items-center justify-center
                disabled:opacity-60
              "
            >
              {t('reviews.list.viewMore')}
            </button>
          </div>
        )}
      </div>
    </section>
  )
}
